import { Passwordpattern } from "../pattern/Pattern";

export const RegisterValid = (name, value) => {

  let error = "";
  if (name === "contactValue") {
    if (value === "") {
      error = "This field is required";
      return error;
    }
    // if (!Emailpattern.test(value) && !Mobilepattern.test(value)) {
    //   error = "This field is required";
    //   return error;
    // }
    return error;
  }
  if (name === "password") {
    
    return validatePasswordSecure(value)
  }
  if (name === "newPassword") {
    if (value === "") {
      error = "This field is required";
      return error;
    }
    if (value.includes(" ")) {
      return "Password cannot contain spaces.";
    }
    if (!Passwordpattern.test(value)) {
      error =
        "Password must 8 characters and contain at least one upper case letter, one lower case letter, one number, and one special character";
      return error;
    }

    return error;
  }
  if (name === "confirmPassword") {
    if (value === "") {
      error = "This field is required";
      return error;
    }
    if (value.includes(" ")) {
      return "Password cannot contain spaces.";
    }
    if (!Passwordpattern.test(value)) {
      error =
        "Password must 8 characters and contain at least one upper case letter, one lower case letter, one number, and one special character";
      return error;
    }

    return error;
  }
  if (name === "verificationCode") {
    if (value === "") {
      error = "This field is required";
      return error;
    }

    if (value.length > 6) {
      error = "Please enter valid verification code";
      return error;
    }

    return error;
  }
  if (name === "refrelId") {
    if (!value) {
      return ""; 
    }
  
    const invalidCharsPattern = /[^A-Z0-9]/;
    if (invalidCharsPattern.test(value)) {
      return "Referral ID can only contain uppercase letters (A-Z) and digits (0-9)";
    }
  
    if (value.length !== 6) {
      return "Referral ID must be exactly 6 characters long";
    }
  
    return ""; 
  }
  
  

  if (name === "email") {
    return validateEmailStrict(value)
  }
  
};

export function validateEmailStrict(value) {
  if (!value) return "This field is required";

  const allowedTLDs = [
    "com", "net", "org", "io", "co", "in", "gov", "edu",
    "tech", "ai", "app", "dev", "info", "biz", "us"
  ];

  // ASCII characters and basic structure check
  const isAsciiFormat = /^[a-zA-Z0-9.]+@[a-zA-Z0-9.]+\.[a-zA-Z]{2,}$/.test(value);
  if (!isAsciiFormat) {
    return "Email can only contain letters, numbers";
  }

  if (value.includes("..")) {
    return "Email cannot contain consecutive dots";
  }

  const [localPart, domainPart] = value.split("@");
  if (!localPart || !domainPart) {
    return "Please enter a valid email address";
  }

  if (
    localPart.startsWith(".") || localPart.endsWith(".") ||
    domainPart.startsWith(".") || domainPart.endsWith(".")
  ) {
    return "Email cannot start or end with a dot";
  }

  if (localPart.length < 3) {
    return "Email must have at least 3 characters before @";
  }

  const domainParts = domainPart.split(".");
  const tld = domainParts[domainParts.length - 1]?.toLowerCase(); // ✅ Lowercased for TLD check

  if (!allowedTLDs.includes(tld)) {
    return "Invalid email domain or TLD. Please enter a valid email address";
  }

  return "";
}



export function validatePasswordSecure(value) {
  console.log("come on")
  if (!value) return "This field is required";

  if (value.includes(" ")) return "Password cannot contain spaces.";

  const suspiciousPatterns = [
    "<script", "<meta", "<iframe", "<img", "<svg", "<object", "<embed", "<link",
    "<style", "<base", "<body", "<input", "<form", "onerror", "onload", "alert",
    "eval", "document", "window", "javascript:", "src=", "href="
  ];

  const lowerValue = value.toLowerCase();

  for (const keyword of suspiciousPatterns) {
    if (lowerValue.includes(keyword)) {
      return "Password contains unsafe content or code-like patterns";
    }
  }

  // Only run complexity pattern check AFTER ensuring safe content
  if (!Passwordpattern.test(value)) {
    return "Password must be 8 characters and contain at least one upper case letter, one lower case letter, one number, and one special character";
  }

  return ""; // ✅ valid password
}




